module.exports = __webpack_public_path__ + "img/nav05.29739b5f.png";